import * as React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";

export default function OrderPageHeader({
  title,
  downloadLabel = "Download",
  onBack = () => {},
  onDownload,
  downloadDisabled = false,
}) {
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "48px 1fr auto", sm: "1fr auto 1fr" },
        alignItems: "center",
        gap: 1,
        px: 2,
        py: 1.25,
        minHeight: 56,
        borderBottom: "1px solid",
        borderColor: "divider",
      }}>
      <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
        <Tooltip title="Back">
          <IconButton aria-label="Back" onClick={onBack} size="small">
            <ArrowBackIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Typography
        component="h1"
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          textAlign: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}>
        {title}
      </Typography>

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        {onDownload && (
          <Button
            variant="contained"
            size="small"
            startIcon={<DownloadOutlinedIcon fontSize="small" />}
            onClick={onDownload}
            disabled={downloadDisabled}
            sx={{ minWidth: 118 }}>
            {downloadLabel}
          </Button>
        )}
      </Box>
    </Box>
  );
}
